import { createAction } from '@reduxjs/toolkit';

const setCalendarSettings = createAction('calendar/setCalendarSettings');

const showToast = createAction('calendar/showToast');
const hideToast = createAction('calendar/hideToast');
const hideTutorial = createAction('calendar/hideTutorial');
const hideReminderTutorial = createAction('calendar/hideReminderTutorial');
const tutorialSecondStep = createAction('calendar/tutorialSecondStep');

export default {
  hideReminderTutorial,
  setCalendarSettings,
  tutorialSecondStep,
  hideTutorial,
  showToast,
  hideToast,
};
